import type { RfqDto } from '../api/types'

import { restaurantSupplierDecision } from './ordersUtils'

export const formatRfqStatus = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'open':
      return 'Открыта'
    case 'draft':
      return 'Черновик'
    case 'closed':
      return 'Закрыта'
    case 'pending':
      return 'Ожидает решения'
    case 'accepted':
      return 'В работе'
    case 'rejected':
      return 'Отклонена'
    case 'awaiting_customer_confirmation':
      return 'Ждёт подтверждения'
    case 'disputed':
      return 'Есть замечания'
    case 'completed':
      return 'Выполнена'
    case 'substitution_proposed':
      return 'Предложена замена'
    case 'cancelled':
      return 'Отменена'
    default:
      return status
  }
}

export const rfqStatusBadgeClass = (status: string): string => {
  switch (status.toLowerCase()) {
    case 'open':
    case 'accepted':
    case 'completed':
      return 'echat-badge echat-badge--success'
    case 'rejected':
    case 'closed':
      return 'echat-badge echat-badge--danger'
    case 'awaiting_customer_confirmation':
    case 'disputed':
    case 'substitution_proposed':
      return 'echat-badge echat-badge--warning'
    case 'pending':
    case 'draft':
    default:
      return 'echat-badge echat-badge--muted'
  }
}

export const restaurantRfqStatusPresentation = (
  rfq: RfqDto,
): { label: string; badgeClass: string } => {
  const decision = restaurantSupplierDecision(rfq)
  const badgeStatus =
    decision === 'awaiting_customer_confirmation' || decision === 'substitution_proposed'
      ? decision
      : rfq.status
  const label =
    decision === 'awaiting_customer_confirmation'
      ? formatRfqStatus(decision)
      : decision === 'substitution_proposed'
        ? formatRfqStatus(decision)
        : formatRfqStatus(rfq.status)

  return {
    label,
    badgeClass: rfqStatusBadgeClass(badgeStatus),
  }
}

export const formatRfqDate = (value: string): string => {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) {
    return value
  }
  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(date)
}

export const isArchivedRestaurantRfq = (rfq: RfqDto): boolean => {
  const status = rfq.status.toLowerCase()
  return status === 'closed' || status === 'cancelled'
}
